import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import TopNavigation from "./TopNavigation";
import OnboardingModal from "../../onboarding/components/OnboardingModal";
import { useOnboardingStatus } from "../../onboarding/services/OnboardingService";
import { ChevronUpIcon, ChevronDownIcon } from "../../../../shared/cockpit/components/icons/Icon";
import "./AppShell.scss";

/**
 * AppShell – wird nach dem Login als Wrapper für alle authentifizierten Routen verwendet.
 *
 * Aufbau:
 *   ┌─────────────────────────────────────────────────┐
 *   │  Header (Logo, Suche, Benachrichtigungen, User) │
 *   ├─────────────────────────────────────────────────┤
 *   │ [Navigation (Dashboard, CRM, Kalkulator) ]      │
 *   │ [Cockpit, Sales)]                                      │
 *   ├─────────────────────────────────────────────────┤
 *   │                                                 │
 *   │  Content (Outlet – hier wird Dashboard, CRM,    │
 *   │  Kalkulator oder Cockpit gerendert)             │
 *   │                                                 │
 *   └─────────────────────────────────────────────────┘
 */


export default function AppShell() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Onboarding-Status pruefen
  const { data: onboardingStatus, isLoading: isLoadingOnboardingStatus } =
    useOnboardingStatus(true);

  // Onboarding-Modal anzeigen, wenn Status geladen und nicht abgeschlossen
  useEffect(() => {
    if (
      !isLoadingOnboardingStatus &&
      onboardingStatus &&
      !onboardingStatus.onboardingCompleted
    ) {
      setShowOnboarding(true);
    }
  }, [onboardingStatus, isLoadingOnboardingStatus]);

  const handleToggleNavigation = () => {
    setIsNavCollapsed((prev) => !prev);
  };

  const handleOnboardingClose = () => {
    setShowOnboarding(false);
  };

  const handleOnboardingCompleted = () => {
    // Nach erfolgreichem Onboarding das Modal schliessen
    setShowOnboarding(false);
  };

  return (
    <div
      className={`app-shell-container${
        isNavCollapsed ? " app-shell-container--nav-collapsed" : ""
      }`}
    >
      {/* 1. Obere Leiste (Logo, Suche, Benachrichtigungen, User-Menü) */}
      <Header />

      {/* 2. Hauptnavigation (Dashboard, CRM, Margenkalkulator, Cockpit, Sales) */}
      {!isNavCollapsed && <TopNavigation />}

      {}
      <button
        type="button"
        className="app-shell-nav-floating-toggle"
        onClick={handleToggleNavigation}
        aria-label={
          isNavCollapsed
            ? "Hauptnavigation ausklappen"
            : "Hauptnavigation einklappen"
        }
        aria-expanded={!isNavCollapsed}
        aria-controls="app-shell-topnav"
        title={
          isNavCollapsed
            ? "Navigation ausklappen"
            : "Navigation einklappen"
        }
      >
        {isNavCollapsed ? (
          <ChevronDownIcon className="app-shell-nav-floating-toggle__icon" />
        ) : (
          <ChevronUpIcon className="app-shell-nav-floating-toggle__icon" />
        )}
      </button>

      {/* 4. Der dynamische Inhaltsbereich */}
      <main className="app-shell-content">
        {/* HIER tauscht React Router die Module gegenseitig aus*/}
        <Outlet />
      </main>

      {/* 5. Onboarding-Modal (wird automatisch nach dem ersten Login angezeigt) */}
      <OnboardingModal
        isOpen={showOnboarding}
        onClose={handleOnboardingClose}
        onCompleted={handleOnboardingCompleted}
      />
    </div>
  );
}
